import { createContext, useContext, useState, useEffect } from 'react';

const AudienceContext = createContext();

export const AUDIENCES = [
  { id: 'patient', label: 'Patient', icon: '🏥', desc: 'Simple explanations, practical guidance' },
  { id: 'student', label: 'Medical Student', icon: '📚', desc: 'Detailed pharmacology & mechanisms' },
  { id: 'professional', label: 'Healthcare Professional', icon: '⚕️', desc: 'Clinical reference & protocols' },
  { id: 'caregiver', label: 'Caregiver / Family', icon: '🤝', desc: 'How to support your loved one' },
];

export function AudienceProvider({ children }) {
  const [audience, setAudience] = useState(() => {
    return localStorage.getItem('dr-ambrish-audience') || null;
  });
  const [showSelector, setShowSelector] = useState(false);

  useEffect(() => {
    if (!audience) {
      const timer = setTimeout(() => setShowSelector(true), 2000);
      return () => clearTimeout(timer);
    }
  }, [audience]);

  const selectAudience = (id) => {
    setAudience(id);
    localStorage.setItem('dr-ambrish-audience', id);
    setShowSelector(false);
  };

  const openSelector = () => setShowSelector(true);

  return (
    <AudienceContext.Provider value={{ audience, selectAudience, showSelector, setShowSelector, openSelector }}>
      {children}
    </AudienceContext.Provider>
  );
}

export function useAudience() {
  const ctx = useContext(AudienceContext);
  if (!ctx) throw new Error('useAudience must be within AudienceProvider');
  return ctx;
}
